<template>
  <complaint-list
    mode="responsible"
    api-url="complaints/my/responsible"
    title="Responsible for me"
    subtitle="Complaints where you are the responsible employee. Open one to give the root cause and corrective action."
    icon="ShieldIcon"
  />
</template>

<script>
import ComplaintList from './ComplaintList.vue'

export default {
  components: { ComplaintList },
}
</script>
